import React, {useState} from "react";
import './blogNewsletterModal.scss';
import Modal from "react-modal";
import SvgClose from "../../../components/ui/icons/SvgClose";
import {useFormik} from "formik";
import * as Yup from "yup";
import {POST_XHTTP} from "../../../services/xhttps";
import Input from "../../../components/ui/form/Input";
import {InputType} from "../../../types/UITypes";
import SvgChevron from "../../../components/ui/icons/SvgChevron";
import {useTranslation} from "gatsby-plugin-react-i18next";

const BlogNewsletterModal = () => {
    const [open, setOpen] = useState(true);
    const toggleModal = () => setOpen(o => !o);
    const {t} = useTranslation('common');

    const handleSubmit = ({email, firstName}: {email: string, firstName: string}) => {
        POST_XHTTP('users/newsletter', { email, firstName })
            .then(() => {
                alert(`Ton inscription a bien été prise en compte !`);
                formik?.resetForm();
            })
            .catch(() => alert('Oops, quelque chose s\'est mal passé...'));
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            firstName: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Adresse email non valide').required('Renseigne une adresse email valide.'),
            firstName: Yup.string(),
        }),
        onSubmit: values => handleSubmit(values),
    });

    return (
        <Modal
            isOpen={open}
            onRequestClose={toggleModal}
            className='blogNLModal'
            overlayClassName='blogNLModalOverlay'
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={300}
        >
            <div className='blogNLModalHeader'>
                <h3>
                    Envie d’avoir de nos nouvelles&nbsp;?
                </h3>
                <div
                    className='returnButton'
                    onClick={toggleModal}
                    title="Fermer"
                >
                    <SvgClose color='#FFF' size={20}/>
                </div>
            </div>
            <p>
                Chaque mois, reçois notre newsletter pleine de bonnes nouvelles et de conseils pour grandir dans ton
                engagement environnemental&nbsp;!
            </p>
            <form
                className={['newsletterForm', 'blogNLForm'].join(' ')}
                onSubmit={formik.handleSubmit}
            >
                <Input
                    value={formik.values.firstName}
                    type={InputType.Text}
                    onChange={formik.handleChange}
                    name='firstName'
                    id='firstnameNL'
                    placeholder='Prénom'
                    errors={formik.errors.firstName}
                    touched={formik.touched.firstName}
                />
                {
                    (formik.touched.email && formik.errors.email)
                        ? (<p><span className='errorText'>{formik.errors.email}</span></p>)
                        : null
                }
                <div className='blogNLFormSubmit'>
                    <Input
                        value={formik.values.email}
                        placeholder={t('newsletter.emailPlaceholder')}
                        type={InputType.Text}
                        onChange={formik.handleChange}
                        name='email'
                        id='contactEmail'
                        errors={formik.errors.email}
                        touched={formik.touched.email}
                    />
                    <button
                        type='submit'
                        role='button'
                        className='inputSendButton'
                        title="S'inscrire"
                    >
                        <SvgChevron direction='right' color='#FFF'/>
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default BlogNewsletterModal;